import { useEffect, useState, Fragment, useRef } from "react";
import styled, { css } from "styled-components";
import "react-tooltip/dist/react-tooltip.css";
import HamburgerNav from "./HamburgerNav";
import moment from "moment";
import {
  RWD_XL,
  RWD_LG,
  RWD_MD,
  RWD_SM,
  RWD_SS,
  RWD_XS,
} from "../../../utils/rwd";
import MiningLineChart from "../MiningLineChart";
import Lang from "../../../global/Lang";
import MiningCoinFuture from "../MiningCoinFuture";
import { specialPackageIdList } from "../configs";
import { BsFillArrowUpCircleFill } from "react-icons/bs";

const DetailWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  font-family: Montserrat;
  width: 100%;
  height: 100%;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding: 2.5vw 1.5625vw 3vw 1.5625vw;
  ${RWD_MD(css`
    padding: 10px 10px 25px 10px;
  `)};
`;

const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 98%;
  gap: 20px;
`;

const DetailContentContainer = styled.div`
  display: flex;
  gap: 20px;
  padding: 0 20px 0 0;
  margin: 60px 0 20px 0;
  ${RWD_MD(css`
    flex-direction: column;
    margin: 20px 0 20px 0;
    padding: 0;
  `)};
`;
const DetailButtonWrapper = styled.div`
  position: absolute;
  right: calc(3.625vw + 20px);
  bottom: 1.625vw;
  color: #fcfcfc;
  font-size: min(max(0.833vw, 14px), 16px);
  cursor: pointer;

  ${RWD_MD(css`
    right: 10px;
    bottom: 10px;
    font-size: 12px;
  `)};
`;
const ProfitWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 45%;
  gap: 20px;
  ${RWD_MD(css`
    width: 100%;
    flex-direction: row;
    gap:8px;
  `)};
`;

const ProfitTitle = styled.div`
  color: #0aecd1;
  font-size: min(max(0.833vw, 14px), 16px);
  padding-bottom: 12px;

  ${RWD_LG(css`
    font-size: 12px;
    align-self: center;
    padding-bottom: 0;
  `)};
`;

const Profit = styled.div`
  height: 100%;
  background-color: #3a3d5a;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${RWD_MD(css`
    padding: 10px;
    width: 100%;
  `)};
`;

const ProfitValueWrapper = styled.div`
  color: #fcfcfc;
  font-size: 1.8vw;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  ${RWD_MD(css`
    flex-direction: column;
    align-items: center;
    margin-top: 8px;
  `)};
`;

const ProfitAmount = styled.div`
  padding-left: 5px;
  ${RWD_MD(css`
    font-size: 16px;
  `)};
`;

const ProfitAmountWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

const ProfitPercentageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #1cac2a;
  ${RWD_MD(css`
    gap: 3px;
    margin-top:8px
  `)};
`;

const ProfitPercentageValue = styled.div`
  padding-right: 5px;
  ${RWD_MD(css`
    font-size: 16px;
    margin-top: 3px;
  `)};
`;

const ProfitPercentageValueContent = styled.div`
  display: flex;
  align-items: baseline;
`;

const ProfitSymbol = styled.div`
  font-size: min(max(1.145vw, 20px), 22px);

  ${RWD_SM(css`
    font-size: min(max(0.9375vw, 16px), 18px);
  `)};
`;

const ArrowUpIcon = styled.div`
  font-size: min(max(0.9375vw, 16px), 18px);
`;

const DetailContainer = ({
  miningData,
  handlePreviewTransferPackage,
  handleSelectTransferPackage,
  WPbuttonHandler,
  lang,
  setShareModalData,
  chartData,
  chartLabel,
  setHistoryModalIsOpen,
  transferUsdt,
}) => {
  if (!miningData) {
    return null;
  } else {
    // 累積獲利（金額）
    const AccumulatedProfit = (profitArray) => {
      if (!profitArray || !Array.isArray(profitArray)) {
        console.warn("profitArray is undefined or not an array:", profitArray);
        return [];
      }
      // 先將每筆獲利轉換成USDT後加總
      // 陣列最後一個值即為累積獲利
      const sum = profitArray.map((item) => {
        return {
          data: calculator(
            item.Profits.map((profit) => transferUsdt(item.Target, profit))
          )[chartLabel.length - 1],
          target: item.Target,
        };
      });

      return sum;
    };

    // 累積獲利（百分比）
    const AccumulatedProfitPercentage = (profitArray) => {
      // 先將每筆數值乘以100後加總
      // 陣列最後一個值即為累積獲利
      if (!profitArray || !Array.isArray(profitArray)) {
        console.warn("profitArray is undefined or not an array:", profitArray);
        return [];
      }
      const sum = profitArray.map((item) => {
        return {
          data: calculator(item.ProfitPercent.map((profit) => profit * 100))[
            chartLabel.length - 1
          ],
          target: item.Target,
        };
      });

      return sum;
    };

    // 三個月累積獲利（金額）
    const ThreeMonthAgoAccumulatedProfit = (profitArray) => {
      if (!profitArray || !Array.isArray(profitArray)) {
        console.warn("profitArray is undefined or not an array:", profitArray);
        return [];
      }
      const sum = profitArray.map((item) => {
        return {
          data: calculator(
            item.Profits.map((profit, index) => {
              const today = moment(); // 獲取當前日期
              const date = moment(chartLabel[index]); // 獲取資料日期
              const diffDays = today.diff(date, "days"); // 獲取兩個日期相差的天數
              // 相差天數小於等於90天，則將獲利轉換成USDT後加總
              // 陣列最後一個值即為累積獲利
              if (diffDays <= 90) {
                return transferUsdt(item.Target, profit);
              } else {
                return 0;
              }
            })
          )[chartLabel.length - 1],
          target: item.Target,
        };
      });
      return sum;
    };

    const calculator = (arr) => {
      return arr.map((data, index, array) => {
        const subArray = array.slice(0, index + 1);
        const sum = subArray.reduce(
          (accumulator, currentValue) => accumulator + currentValue,
          0
        );

        return sum;
      });
    };
    // 三個月累積獲利（百分比）
    const ThreeMonthAgoAccumulatedProfitPercentage = (profitArray) => {
      if (!profitArray || !Array.isArray(profitArray)) {
        console.warn("profitArray is undefined or not an array:", profitArray);
        return [];
      }
      const sum = profitArray.map((item) => {
        return {
          data: calculator(
            item.ProfitPercent.map((profit, index) => {
              const today = moment(); // 獲取當前日期
              const date = moment(chartLabel[index]); // 獲取資料日期
              const diffDays = today.diff(date, "days"); // 獲取兩個日期相差的天數
              // 相差天數小於等於90天，則將數值乘以100後加總
              // 陣列最後一個值即為累積獲利
              if (diffDays <= 90) {
                return profit * 100;
              } else {
                return 0;
              }
            })
          )[chartLabel.length - 1],
          target: item.Target,
        };
      });
      return sum;
    };

    return (
      <DetailWrapper>
        <HamburgerNav
          data={miningData}
          handlePreviewTransferPackage={handlePreviewTransferPackage}
          handleSelectTransferPackage={handleSelectTransferPackage}
          WPbuttonHandler={WPbuttonHandler}
          language={lang}
          setShareModalData={setShareModalData}
        />
        <DetailContent>
          {specialPackageIdList.every((id) => id !== miningData.PackageId) && (
            <DetailContentContainer>
              <MiningLineChart
                chartData={chartData}
                chartLabel={chartLabel}
                chartName={miningData.PackageName}
              />

              <ProfitWrapper>
                <Profit>
                  <ProfitTitle>
                    <Lang
                      datakey="cumulative_profit"
                      defaultText="Cumulative Profit"
                    />
                  </ProfitTitle>

                  <ProfitValueWrapper>
                    <ProfitAmountWrapper>
                      <ProfitSymbol>$</ProfitSymbol>
                      <ProfitAmount>
                        {AccumulatedProfit(chartData || [])
                          .map((data) => data.data)
                          .reduce(
                            (accumulator, currentValue) =>
                              accumulator + currentValue,
                            0
                          )
                          .toFixed(2)}
                      </ProfitAmount>
                    </ProfitAmountWrapper>

                    <ProfitPercentageWrapper>
                      <ArrowUpIcon>
                        <BsFillArrowUpCircleFill />
                      </ArrowUpIcon>
                      <ProfitPercentageValueContent>
                        <ProfitPercentageValue>
                          {AccumulatedProfitPercentage(chartData)
                            .map((data) => data.data)
                            .reduce(
                              (accumulator, currentValue) =>
                                accumulator + currentValue,
                              0
                            )
                            .toFixed(2)}
                        </ProfitPercentageValue>
                        <ProfitSymbol>%</ProfitSymbol>
                      </ProfitPercentageValueContent>
                    </ProfitPercentageWrapper>
                  </ProfitValueWrapper>
                </Profit>
                <Profit>
                  <ProfitTitle>
                    <Lang
                      datakey="three_month_profit"
                      defaultText="Three-Month Profit"
                    />
                  </ProfitTitle>
                  <ProfitValueWrapper>
                    <ProfitAmountWrapper>
                      <ProfitSymbol>$</ProfitSymbol>
                      <ProfitAmount>
                        {ThreeMonthAgoAccumulatedProfit(chartData)
                          .map((data) => data.data)
                          .reduce(
                            (accumulator, currentValue) =>
                              accumulator + currentValue,
                            0
                          )
                          .toFixed(2)}
                      </ProfitAmount>
                    </ProfitAmountWrapper>

                    <ProfitPercentageWrapper>
                      <ArrowUpIcon>
                        <BsFillArrowUpCircleFill />
                      </ArrowUpIcon>
                      <ProfitPercentageValueContent>
                        <ProfitPercentageValue>
                          {ThreeMonthAgoAccumulatedProfitPercentage(chartData)
                            .map((data) => data.data)
                            .reduce(
                              (accumulator, currentValue) =>
                                accumulator + currentValue,
                              0
                            )
                            .toFixed(2)}
                        </ProfitPercentageValue>
                        <ProfitSymbol>%</ProfitSymbol>
                      </ProfitPercentageValueContent>
                    </ProfitPercentageWrapper>
                  </ProfitValueWrapper>
                </Profit>
              </ProfitWrapper>
            </DetailContentContainer>
          )}

          {/* 僅有PackageId = 38 39 40 41 42 才顯示幣種增量區塊 */}
          {specialPackageIdList.includes(miningData.PackageId) && (
            <MiningCoinFuture
              packageId={miningData.PackageId}
              groudId={miningData.GroupId}
            />
          )}
          {/* <MiningCoinFuture
        packageId={miningData.PackageId}
        groudId={miningData.GroupId}
      /> */}
        </DetailContent>

        <DetailButtonWrapper onClick={() => setHistoryModalIsOpen(true)}>
          <Lang datakey="detail" defaultText="detail" />
        </DetailButtonWrapper>
      </DetailWrapper>
    );
  }
};
export default DetailContainer;
